// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'receipt';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.5 16.367c0 .3-.122.589-.338.801-.216.213-.51.332-.816.332H2.654c-.306 0-.6-.12-.816-.332a1.124 1.124 0 0 1-.338-.801V1.633c0-.3.122-.589.338-.801.216-.213.51-.332.816-.332h8.176c.306 0 .6.12.815.332l4.517 4.436c.217.213.338.5.338.801z' />
    <path d='M16.5 6.167h-4.615c-.306 0-.6-.12-.816-.332s-.338-.501-.338-.802V.5M4.538 8.693a1.71 1.71 0 0 0 1.43.661c.876 0 1.587-.523 1.587-1.168 0-.646-.709-1.168-1.584-1.168-.876 0-1.586-.524-1.586-1.17s.71-1.169 1.586-1.169c.275-.01.548.044.797.159s.466.287.632.502M5.97 9.354v.78m0-6.234v.779M9 11.267h4.615m-8.653 3.4h8.653' />
  </g>
);

export const viewBox = '0 0 18 18';
